__turbopack_context__.v({
  "createAccountButton": "LoginForm-module-scss-module__uNbDYq__createAccountButton",
  "formContainer": "LoginForm-module-scss-module__uNbDYq__formContainer",
  "isDisabled": "LoginForm-module-scss-module__uNbDYq__isDisabled",
  "loginButton": "LoginForm-module-scss-module__uNbDYq__loginButton",
  "loginErrorMessage": "LoginForm-module-scss-module__uNbDYq__loginErrorMessage",
});
